import {
  BETSLIP_TABS,
  BetType,
  BUTTON_SELECTION,
  OddsFormat,
  OddsFormatHR,
  PrefsMap,
  RoundRobinOption,
  ViewKeys,
  WinRiskType,
  SimplifiedBetType,
  SimplifiedOriginalBetType,
  SimplifiedSelectionType,
} from "../../../../common/Foundation";
import BetslipCommon from "../../../../common/BetslipCommon";
import Constants from "../../../../common/Constants";
import cookie from 'react-cookies';
import CommonUtil from "../../../../common/CommonUtil";
import _, {isEmpty} from 'lodash';
import moment from 'moment';
import $ from 'jquery'
import { Base64 } from 'js-base64';
import { EVENT } from "../../../../events/listEvents";
import includes from 'lodash/includes';
import {getMomentTZ} from '../../../../common/DateUtils';

export default class BetslipHelper {

  /**
   * Get odds information when click on single tab
   * @param {*} oddsSelections
   */
  static buildSingleOddsSelectionRequest(oddsSelections, oddsFormat) {
    const payload = oddsSelections.reduce((filtered, selection) => {
      filtered.push({
        oddsFormat: oddsFormat,
        oddsId: selection.oddsId,
        oddsSelectionsType: selection.oddsSelectionsType,
        selectionId: selection.selectionId,
      })
      return filtered;
    }, []);
    return {
      oddsSelections: payload
    }
  }

  static validateSingleBets = (bets, stakeInputs, oddsFormat) => {
    let validationMessage = ''
    let adjustStakes = []
    bets.forEach((bet) => {
      if ((!bet.errorCode || bet.errorCode === Constants.BET_ERROR_CODE.LINE_CHANGED || bet.errorCode === Constants.BET_ERROR_CODE.MAX_BET_EXCEEDED) &&
          (bet.status !== Constants.UNAVAILABLE && bet.status !== Constants.BET_STATUS.ACCEPTED && bet.status !== Constants.BET_STATUS.PENDING_ACCEPTANCE)) {
        const stake = BetslipCommon.convertStakeToNumber(BetslipHelper.getStake(stakeInputs, bet.oddsId))
        const minStake = BetslipCommon.getMinWinRiskByOddFormat(oddsFormat, stakeInputs[bet.oddsId].winRiskOption, bet)
        const maxStake = BetslipCommon.getMaxWinRiskByOddFormat(oddsFormat, stakeInputs[bet.oddsId].winRiskOption, bet)
        const isPA = CommonUtil.isPA();
        if (bet.maxStake === 0) {
          validationMessage = Constants.MAX_ZERO_MESSAGE;

        } else if (!stake || stake < minStake) {
          validationMessage = validationMessage === Constants.INVALID_MAX_STAKE ? Constants.INVALID_MAX_MIN_STAKE : Constants.INVALID_MIN_STAKE;
          adjustStakes.push({
            oddsId: bet.oddsId,
            minStake: minStake,
            error: Constants.INVALID_MIN_STAKE
          })
        } else if (stake > maxStake) {
          validationMessage = !isPA && bet.maxBetPerMatch === 0 ?
            Constants.MAX_ZERO_MESSAGE :
            validationMessage === Constants.INVALID_MIN_STAKE ? Constants.INVALID_MAX_MIN_STAKE : Constants.INVALID_MAX_STAKE;
            adjustStakes.push({
              oddsId: bet.oddsId,
              maxStake: maxStake,
              error: Constants.INVALID_MAX_STAKE
            })
        }
      }
    })
    return {
      errorMessage: validationMessage,
      adjustStakes: adjustStakes
    }
  }

  static validateHRSingleBets = (bets, stakeInputs, limitBets, preValidator, loginId, oddsFormat) => {
    let validationMessage = '';
    const adjustStakes = {};
    bets.forEach(bet => {
      const {oddsId, status} = bet;
      if (status !== Constants.HR_BET_STATUS.ACCEPTED) {
        const matchingStake = stakeInputs[oddsId];
        const limitBet = limitBets[oddsId];
        if (matchingStake && limitBet) {
          const minStake = BetslipCommon.getRBMinMaxBet(BetslipCommon.getMinWinRiskByOddFormatRB(matchingStake.winRiskOption, limitBet));
          const maxStake = BetslipCommon.getRBMinMaxBet(BetslipCommon.getMaxWinRiskByOddFormatRB(matchingStake.winRiskOption, limitBet));
          const stake = BetslipCommon.convertStakeToNumber(BetslipHelper.getStake(stakeInputs, oddsId))
          if (stake > maxStake) {
            validationMessage = validationMessage === Constants.INVALID_MIN_STAKE ? Constants.INVALID_MAX_MIN_STAKE : Constants.INVALID_MAX_STAKE;
            if(matchingStake.winRiskOption === WinRiskType.WIN) {
              const riskVal = BetslipCommon.calculateToRisk(maxStake, matchingStake.odds, oddsFormat, matchingStake.winRiskOption);
              adjustStakes[oddsId] = {...matchingStake, oddsId, baseVal: maxStake, winVal: maxStake, riskVal: riskVal};
            } else {
              const winVal = BetslipCommon.calculateToWin(maxStake, matchingStake.odds, oddsFormat, matchingStake.winRiskOption, '');
              adjustStakes[oddsId] = {...matchingStake, oddsId, baseVal: maxStake, riskVal: maxStake, winVal: winVal};
            }
          } else if (!stake || stake < minStake) {
            validationMessage = validationMessage === Constants.INVALID_MAX_STAKE ? Constants.INVALID_MAX_MIN_STAKE : Constants.INVALID_MIN_STAKE;
            if(matchingStake.winRiskOption === WinRiskType.WIN) {
              const riskVal = BetslipCommon.calculateToRisk(minStake, matchingStake.odds, oddsFormat, matchingStake.winRiskOption);
              adjustStakes[oddsId] = {...matchingStake, oddsId, baseVal: minStake, winVal: minStake, riskVal: riskVal};
            } else {
              const winVal = BetslipCommon.calculateToWin(minStake, matchingStake.odds, oddsFormat, matchingStake.winRiskOption, '');
              adjustStakes[oddsId] = {...matchingStake, oddsId, baseVal: minStake, riskVal: minStake, winVal: winVal};
            }
          }
        } 
      }
    });
    return {
      validator: validationMessage ? {...preValidator, errorMessage: validationMessage} : preValidator,
      hrAdjustStakes: adjustStakes
  }
  }

  static autoAdjustStake(stakeInputs, oddsFormat, validator) {
    const inputs = JSON.parse(JSON.stringify(stakeInputs))
    if (validator.adjustStakes.length > 0) {
      validator.adjustStakes.forEach((item, index) => {
        if (Object.keys(inputs[item.oddsId]).length > 0) {
          let stake = 0;
          if (item.error === Constants.INVALID_MIN_STAKE) {
            stake = item.minStake;
          }
          if (item.error === Constants.INVALID_MAX_STAKE) {
            stake = item.maxStake;
          }
          let riskVal = 0;
          let winVal = 0;
          switch (inputs[item.oddsId].winRiskOption) {
            case WinRiskType.RISK:
              riskVal = stake;
              winVal = BetslipCommon.calculateToWin(stake, inputs[item.oddsId].odds, oddsFormat, inputs[item.oddsId].winRiskOption, inputs[item.oddsId].betType);
              break;
            case WinRiskType.WIN:
              winVal = stake;
              riskVal = BetslipCommon.calculateToRisk(stake, inputs[item.oddsId].odds, oddsFormat, inputs[item.oddsId].winRiskOption);
              break;
            default:
              if (inputs[item.oddsId].odds > 0) {
                riskVal = stake;
                winVal = BetslipCommon.calculateToWin(stake, inputs[item.oddsId].odds, oddsFormat, inputs[item.oddsId].winRiskOption, inputs[item.oddsId].betType);
              } else {
                winVal = stake;
                riskVal = BetslipCommon.calculateToRisk(stake, inputs[item.oddsId].odds, oddsFormat, inputs[item.oddsId].winRiskOption);
              }
          }
          Object.assign(inputs[item.oddsId], {
            riskVal,
            winVal,
            baseVal:
              BetslipHelper.calculateBaseVal(inputs[item.oddsId]
                && inputs[item.oddsId].baseVal,
                inputs[item.oddsId].odds,
                riskVal,
                winVal)
          });
        }
      })
    }
    return inputs;
  }

  static getStake = (stakeInputs, oddsId) => {
    let stake = 0
    if (oddsId) { // multiple stakes will pass in oddsId to identify
      const winRiskOption = stakeInputs[oddsId] && stakeInputs[oddsId].winRiskOption;
      if (winRiskOption === WinRiskType.RISK) {
        stake = BetslipCommon.convertStakeToNumber(stakeInputs[oddsId].riskVal)
      } else if (winRiskOption === WinRiskType.WIN) {
        stake = BetslipCommon.convertStakeToNumber(stakeInputs[oddsId].winVal)
      } else if (winRiskOption === WinRiskType.BASE) {
        stake = BetslipCommon.convertStakeToNumber(stakeInputs[oddsId].baseVal)
      }

    } else { // single stake currently use for teaser bet (oddsId will not be passed in)
      const winRiskOption = stakeInputs && stakeInputs.winRiskOption;
      if (winRiskOption === WinRiskType.RISK) {
        stake = BetslipCommon.convertStakeToNumber(stakeInputs.riskVal)
      } else if (winRiskOption === WinRiskType.WIN) {
        stake = BetslipCommon.convertStakeToNumber(stakeInputs.winVal)
      } else if (winRiskOption === WinRiskType.BASE) {
        stake = BetslipCommon.convertStakeToNumber(stakeInputs.baseVal)
      }
    }

    return stake
  }

  static buildPayloadPlaceSingleBets(bets, stakeInputs, pitchers, oddFormat, acceptBetterOdds) {
    let selections = [];
    bets.forEach((bet, index) => {
      if (!BetslipHelper.isSuccessfullyBet(bet.status)) {
        const selection = {
          odds: bet.odds,
          oddsId: bet.oddsId,
          selectionId: bet.selectionId,
          stake: BetslipHelper.getStake(stakeInputs, bet.oddsId),
          uniqueRequestId: BetslipCommon.generateUUID(),
          wagerType: bet.oddsSelectionsType === Constants.WAGER_TYPE.PARLAY ? Constants.WAGER_TYPE.NORMAL : bet.oddsSelectionsType
        }
        if (Number(oddFormat) === OddsFormat.AM || Number(oddFormat) === OddsFormat.EU) {
          selection.winRiskStake = stakeInputs[bet.oddsId].winRiskOption;
        }
        if (bet.sportId === Constants.BASEBALL_ID && bet.betType === BetType.THE_1X2 && bet.baseBall) {
          const pitcher = pitchers[bet.oddsId]
          Object.keys(pitcher).forEach(key => {
            if (pitcher[key]) {
              selection[key] = pitcher[key]
            }
          })
        }
        selections.push(selection);
      }
    })
    return {
      acceptBetterOdds: acceptBetterOdds,
      oddsFormat: oddFormat,
      selections: selections
    }
  }

  static buildHRPayloadPlaceSingleBets = (bets, stakeInputs, oddFormat, acceptBetterOdds) => {
    const revertedOddsFormatHR = {};
    Object.entries(OddsFormatHR).forEach(([key, value]) => {
      revertedOddsFormatHR[value] = key;
    });
    return bets.map(bet => {
      const {betSlipEmit, oddsDisplay, odds, currencyCode, oddsId} = bet;
      const {
        legs,
      } = betSlipEmit;
      const {
        runnerNumber,
        betType,
        runnerName,
        meetingId,
        raceNumber,
        selections,
        productType,
        startTime,
        raceName,
        venue,
        jockeyName,
      } = legs[0];
      const legType = legs[0].type;
      const winRiskOption = stakeInputs[oddsId] && stakeInputs[oddsId].winRiskOption;
      const stake = Number(BetslipHelper.getStake(stakeInputs, bet.oddsId));
      return {
        appId: ViewKeys.compact,
        acceptBetterOdds: acceptBetterOdds,
		oddsType: revertedOddsFormatHR[oddFormat],
        currency: currencyCode,
        legs: [{
          betType,
          jockeyName: jockeyName || '',
          meetingId,
          odds: Number(odds),
          productType,
          raceDate: startTime,
          raceName,
          raceNumber,
          runnerName,
          runnerNumber,
          selections,
          type: legType,
          userOdds: Number(oddsDisplay),
          venue,
        }],
        oddsFormat: revertedOddsFormatHR[oddFormat],
        stake,
        type: 'SINGLE',
        winRiskOption,
        uniqueRequestId: BetslipCommon.generateUUID(),
      }
    })
  };

  static buildHROddsId = (bet) => {
    const {
      betType,
      raceNumber,
      runnerNumber,
      meetingId,
    } = bet;
    return `${meetingId}-${raceNumber}-${runnerNumber}-${betType}`;
  };

  static buildHROddsIdNoBetType = (bet) => {
    const {
      raceNumber,
      runnerNumber,
      meetingId,
    } = bet;
    return `${meetingId}-${raceNumber}-${runnerNumber}`;
  };

  static calculateTotalStake = (inputs) => {
    let totalStake = 0;
    Object.values(inputs).forEach(input => {
      totalStake += BetslipCommon.convertStakeToNumber(inputs[input.oddsId].riskVal)
    })
    return totalStake
  }

  static isSelectedOdd = (selection, selections) => {
    let oddsArray = selection.oddsId.split('|');
    let eventId = Number(oddsArray[0]);
    let period = Number(oddsArray[1]);
    let betType = Number(oddsArray[2]);
    let hdp = Math.abs(Number(oddsArray[5]));
    return selections.findIndex(sel => {
      let arraySel = sel.oddsId.split('|');
      return Number(arraySel[0]) === eventId && Number(arraySel[1]) === period && Number(arraySel[2]) === betType && Math.abs(Number(arraySel[5])) === hdp;
    })
  }

  static calculatePotentialWinnings = (inputs) => {
    let totalPotentialWinnings = 0;
    Object.values(inputs).forEach(input => {
      totalPotentialWinnings += BetslipCommon.convertStakeToNumber(input.winVal || 0)
    })
    return totalPotentialWinnings
  }

    /**
   * Update selection after line change
   * @param {*} selectionId 
   * @param {*} infoNeedUpdate 
   */
  static generateNewSelectionId(selectionId, infoNeedUpdate) {
    const newSelectionId = [];
    selectionId = selectionId.split('|');
    const SELECTION_ID_MAP = {
      lineId: 0,
      altLineId: 1,
      eventId: 2,
      periodNum: 3,
      betType: 4,
      selectionType: 5,
      alt: 6,
      spread: 7,
      teamType: 8
    }
    newSelectionId.push(infoNeedUpdate.lineId);
    newSelectionId.push(infoNeedUpdate.altLineId ? infoNeedUpdate.altLineId : 0);
    newSelectionId.push(selectionId[SELECTION_ID_MAP.eventId]);
    newSelectionId.push(selectionId[SELECTION_ID_MAP.periodNum]);
    newSelectionId.push(selectionId[SELECTION_ID_MAP.betType]);
    newSelectionId.push(selectionId[SELECTION_ID_MAP.selectionType]);
    newSelectionId.push(infoNeedUpdate.altLineId > 0 ? 1 : 0);
    newSelectionId.push(selectionId[SELECTION_ID_MAP.spread]);
    newSelectionId.push(selectionId[SELECTION_ID_MAP.teamType]);
    return newSelectionId.join('|');
  }

  static convertBetPlacementErrorCode(errorCode) {
    let convertedCode
    switch (errorCode) {
      case Constants.BET_ERROR_CODE.ABOVE_MAX_BET_AMOUNT:
        convertedCode = Constants.BET_ERROR_CODE.ERROR3103
        break
      case Constants.BET_ERROR_CODE.BELOW_MIN_BET_AMOUNT:
        convertedCode = Constants.BET_ERROR_CODE.ERROR3104
        break
      case Constants.BET_ERROR_CODE.ODDS_CHANGE: 
        convertedCode = Constants.BET_ERROR_CODE.ODDS_CHANGED
        break
      default:
        convertedCode = errorCode
    }
    return convertedCode
  }

  static addOldOdds = (oddsSelection, bets, oddsFormat) => {
    return bets.reduce((newBets, bet) => {
      if (bet.status === Constants.ODDS_STATUS.ODDS_CHANGE) {
        const filter = oddsSelection.filter(selection => {
          return selection.oddsId === bet.oddsId;
        })
        if (filter.length > 0) {
          const odds = BetslipCommon.formatOddsValue(filter[0].odds, filter[0].oddsFormat)
          // odds is the same if betType is 1x2 and oddsFormat is EU, HK or MY
          const arr = [OddsFormat.EU, OddsFormat.HK, OddsFormat.MY]
          const isKeepOdd = bet.betType === BetType.THE_1X2 && arr.indexOf(oddsFormat) > -1 && arr.indexOf(filter[0].oddsFormat) > -1
          if (filter[0].oddsFormat !== oddsFormat && !isKeepOdd) {
            bet.oldOdds = BetslipCommon.convertOddsByOddsFormat(odds, filter[0].oddsFormat, oddsFormat) 
          } else {
            bet.oldOdds = odds
          }
        }
      }
      newBets.push(bet)
      return newBets
    }, [])
  }

  static isOddsChange = (bets) => {
    const filter = bets.filter(bet => {
      return bet.status === Constants.ODDS_STATUS.ODDS_CHANGE
    })
    return filter.length > 0
  }
  
  static isOddsChangeOnLegs = (legs) => {
    const filter = legs.filter(leg => {
      return !leg.errorCode && leg.legStatus === Constants.ODDS_STATUS.ODDS_CHANGE
    })
    return filter.length > 0
  }

  static addOldOddsForLegs = (oddsSelection, parlayOddsRequest, legs) => {
    return legs.reduce((newLegs, leg) => {
      if (leg.legStatus === Constants.ODDS_STATUS.ODDS_CHANGE) {
        const oddsId = BetslipHelper.getOddsIdByLegId(oddsSelection, parlayOddsRequest, leg.legId)
        const filter = oddsSelection.filter(selection => {
          return selection.oddsId === oddsId
        })
        if (filter.length > 0) {
          leg.oldOdds = filter[0].odds
        }
      }
      newLegs.push(leg)
      return newLegs
    }, [])
  }

  /**
   * Transfer info from user's selection to legs data for rendering, sorting, or any purpose
   * Note that values in array props is a field name that must be exist in selection object.
   * Example:
   * We have the selection object {name: 'test', age: '2} then data in array props must be 'name', 'age' or
   * both 'name' and 'age'
   * @param {*} oddsSelection 
   * @param {*} parlayOddsRequest 
   * @param {*} legs 
   * @param {*} propsName 
   * @returns 
   */
  static addPropsToLegs = (oddsSelection, parlayOddsRequest, legs, propsName) => {
    return legs.reduce((newLegs, leg) => {
      const oddsId = BetslipHelper.getOddsIdByLegId(oddsSelection, parlayOddsRequest, leg.legId)
      const filter = oddsSelection.filter(selection => {
        return selection.oddsId === oddsId
      })
      if (filter.length > 0) {
        propsName.forEach(name => {
          leg[name] = filter[0][name]
        })
      }
      newLegs.push(leg)
      return newLegs
    }, [])
  }

static updateOddsForStakeInputs = (stakeInputs, bets, oddsFormat) => {
    const newStakeInputs = JSON.parse(JSON.stringify(stakeInputs))
    bets.forEach((bet, index) => {
      const currentInput = newStakeInputs[bet.oddsId]
      if (currentInput) {
        let winRiskOption = currentInput.winRiskOption
        if (oddsFormat !== OddsFormat.AM && oddsFormat !== OddsFormat.EU) {
          winRiskOption = BetslipHelper.getWinRiskOptionByOdds(bet.odds)
        }
        if ((currentInput.riskVal && winRiskOption === WinRiskType.RISK)
          || (winRiskOption === WinRiskType.BASE && bet.odds > 0)) {
          const riskVal = BetslipCommon.convertStakeToNumber(currentInput.riskVal)
          currentInput.winVal = BetslipCommon.calculateToWin(riskVal, bet.odds, oddsFormat, WinRiskType.RISK, bet.betType);
        } else if ((currentInput.winVal && winRiskOption === WinRiskType.WIN)
          || (winRiskOption === WinRiskType.BASE && bet.odds < 0)) {
          const winVal = BetslipCommon.convertStakeToNumber(currentInput.winVal)
          currentInput.riskVal = BetslipCommon.calculateToRisk(winVal, bet.odds, oddsFormat, WinRiskType.WIN)
        }
        // Odds change will update stake for win/risk/base
        currentInput.baseVal = BetslipHelper.calculateBaseVal(currentInput.baseVal,
          bet.odds,
          currentInput.riskVal,
          currentInput.winVal);
        currentInput.odds = bet.odds
        currentInput.winRiskOption = winRiskOption
      }
  })
  return newStakeInputs
}
  
static getOddsIdByLegId = (oddsSelection, parlayOddsRequest, legId) => {
  const { parlayOddsSelections } = parlayOddsRequest.parlayOddsRequest
  if (parlayOddsSelections) {
    const parlay = parlayOddsSelections.filter((odds, index) => {
      return odds.legId === legId
    })
    if (parlay.length > 0) {
      const selection = oddsSelection.filter((odds, index) => {
        return odds.selectionId === parlay[0].selectionId
      })
      if (selection.length > 0) {
        return selection[0].oddsId
      }
    }
  }
}

static getLegIdByOddsId = (oddsSelection, parlayOddsRequest, oddsId) => {
  const { parlayOddsSelections } = parlayOddsRequest.parlayOddsRequest

  const selection = oddsSelection.filter((odds, index) => {
    return odds.oddsId === oddsId
  })
  if (selection.length > 0) {
    const parlay = parlayOddsSelections.filter((odds, index) => {
      return odds.selectionId === selection[0].selectionId
    })
    if (parlay.length > 0) {
      return parlay[0].legId
    }
  }
}

/**
 * Transfer info from user's selection to sing bets data for rendering, sorting, or any purpose
 * Note that values in array props is a field name that must be exist in selection object.
 * Example:
 * We have the selection object {name: 'test', age: '2} then data in array props must be 'name', 'age' or
 * both 'name' and 'age'
 * @param {*} oddsSelection 
 * @param {*} bets 
 * @param {*} props 
 * @returns 
 */
  static transferInfoFromSelectionToSingleBets = (oddsSelection, bets, props) => {    
    return (
      oddsSelection.map(selection => {
        const item = bets.filter(item => {
          return item.oddsId === selection.oddsId
        })
        if (item.length > 0) {
          const filter = (props || []).filter(prop => selection[prop]);
          const transferObj = filter.map(prop => {
            return {
              [prop]: selection[prop]
            }
          })
          return {
            ...item[0],
            ...(transferObj[0] || {})
          }
        }
        return false;
      }).filter(selection => selection)
    )
  }

  /**
   * To check odds selection has been support parlay or not
   * @param {odds selection} selection 
   */
  static isAllowParlay (selection){
    const betType = selection.selectionId.split('|')[3];
    return selection.parlayRestriction !== 1 && includes([
      BetType.HANDICAP,
      BetType.OU,
      BetType.THE_1X2,
      BetType.HOME_TOTALS,
      BetType.AWAY_TOTALS
    ], parseInt(betType))
  }

   /**
   * Get odds information when click on single tab
   * @param {*} oddsSelections 
   */
  static buildParlayOddsSelectionRequest(oddsSelections, oddsFormat) {
    const payload = oddsSelections.reduce((filtered, selection) => {
      if (this.isAllowParlay(selection)) {
        filtered.push({
          legId: BetslipCommon.generateUUID(),
          selectionId: selection.selectionId
        })
      }
      return filtered;
    }, []);
    return {
      parlayOddsRequest: {
        oddsFormat: oddsFormat,
        parlayOddsSelections:  payload,
        ticketId: BetslipCommon.generateUUID()
      }
    }
  }
  /**
     * Calculate Parlay with Round Robin Max payout
     */
    static calculateParlayWithRROMaxPayout(stake, availableRROs, selectedRROs, oddsFormat) {
      let payout = 0
      if (!stake || stake === 0) {
        return payout
      }
      let convertedStake = BetslipCommon.convertStakeToNumber(stake)
      // Loop through the available RROs and calculate
      if (selectedRROs.length === 0) {
        selectedRROs = [RoundRobinOption.PARLAY]
      }
      availableRROs.forEach(roundRobin => {
        if (selectedRROs.indexOf(roundRobin.roundRobinOption) > -1) {
          payout += BetslipCommon.calculateParlayPayoutByRRO(roundRobin, convertedStake, oddsFormat)
        }
      })
      return payout
    }
    static validateAsiaParlayBetItem(parlayTicket, stake, maxRoundRobinRiskStake) {
      let errors = {}
      if (!stake) {
        stake = 0
      }
      const minStake = parlayTicket.minRiskStake
      const maxStake = maxRoundRobinRiskStake
      const convertedStake = BetslipCommon.convertStakeToNumber(stake)
  
      if (!convertedStake || convertedStake < minStake) {
        errors.message = Constants.INVALID_MIN_STAKE
        errors.stake = minStake
      } else if (convertedStake > maxStake) {
        errors.message = Constants.INVALID_MAX_STAKE
        errors.stake = maxStake
      }
      return errors
    }
    
  static getParlayWinRiskInfo = (stake, availableRROs, selectedRROs, oddsFormat) => {
      let winriskInfo = { toWin: 0, totalStake: 0}
      if (!stake || stake === 0) {
        return winriskInfo
      }
      if (availableRROs && availableRROs.length > 0) {
        let convertedStake = BetslipCommon.convertStakeToNumber(stake)
         // Loop through the available RROs and calculate
         if (selectedRROs.length === 0) {
          const rro = availableRROs.filter((rro, index) => {
            return rro.roundRobinOption === RoundRobinOption.PARLAY
          })[0]
          winriskInfo = BetslipCommon.calculateWinRiskInfo(winriskInfo, rro, convertedStake, oddsFormat)
         } else {
           availableRROs.forEach((roundRobin, index) => {
             if (selectedRROs.indexOf(roundRobin.roundRobinOption) > -1) {
               winriskInfo = BetslipCommon.calculateWinRiskInfo(winriskInfo, roundRobin, convertedStake, oddsFormat)
             }
           })
         }
      }

    return winriskInfo
  }

  static getHRParlayWinRiskInfo = (stake, availableRROs, selectedRROs, oddsFormat) => {
    let winriskInfo = { toWin: 0, totalStake: 0 }
    if (!stake || stake === 0) {
      return winriskInfo
    }
    if (availableRROs && availableRROs.length > 0) {
      let convertedStake = BetslipCommon.convertStakeToNumber(stake)
      if (selectedRROs.length === 0) {
        const rro = availableRROs.filter((rro, index) => {
          return rro.roundRobinOption === RoundRobinOption.PARLAY
        })[0]
        const rrb = { ...rro, odds: rro.totalOdds }
        winriskInfo = BetslipCommon.calculateWinRiskInfo(winriskInfo, rrb, convertedStake, oddsFormat)
      } else {
        availableRROs.forEach((roundRobin, index) => {
          if (selectedRROs.indexOf(roundRobin.roundRobinOption) > -1) {
            const rrb = { ...roundRobin, odds: roundRobin.totalOdds }
            winriskInfo = BetslipCommon.calculateWinRiskInfo(winriskInfo, rrb, convertedStake, oddsFormat)
          }
        })
      }
    }
    return winriskInfo
  }

  static buildParlayBetPayload(ticketId, stake, oddsFormat, parlayAcceptBetterOdds, selectedRoundRobinOptions) {
    return {
      oddsFormat: oddsFormat,
      acceptBetterOdds: parlayAcceptBetterOdds,
      roundRobinOptions: selectedRoundRobinOptions,
      stake: BetslipCommon.convertStakeToNumber(stake),
      ticketId: ticketId,
      uniqueRequestId: BetslipCommon.generateUUID(),
      winRiskStake: WinRiskType.RISK // default for parlay
    }
  }

  static buildParlayUpdateTicketPayload(ticketId, oddsFormat, legs) {
    let legsInfo = legs.map(leg => { 
      return { 
        legId: leg.legId,
        selectionId: leg.selectionId 
      }
    })

    return {
      ticketId: ticketId,
      ot: oddsFormat,
      parlayLegs: JSON.stringify(legsInfo),
      _: new Date().getTime()
    }
  }

    /**
   * Build payload to get teaser odds information when click on teaser tab
   * @param {*} oddSelections 
   * @param {*} oddsFormat 
   */
  static buildTeaserBetTicketParams(oddSelections, oddsFormat) {
    let legs = [];
    oddSelections.forEach(selection => {
        legs.push({
          legId: BetslipCommon.generateUUID(),
          selectionId: selection.selectionId
        })
    })
    return {
      teaserId: oddSelections[0].teaserId,
      ticketId: BetslipCommon.generateUUID(),
      oddsFormat: oddsFormat,
      legs: JSON.stringify(legs)
    }
  }

  static updateMoreInfoForTeaserOddsResponse = (teaserSelections, teaserOddsPayload, teaserBets, minLegs) => {
    const {
      legs
    } = teaserOddsPayload

    // get more information from teaser odds selections
    const extraInfo = JSON.parse(legs).reduce((extraInfo, leg) => {
      const selection = teaserSelections.filter((sel, index) => {
        return sel.selectionId === leg.selectionId
      })
      if (selection.length > 0) {
        extraInfo[leg.legId] = {
          sportId: selection[0].sportId,
          homeTeam: selection[0].homeTeam,
          awayTeam: selection[0].awayTeam,
          selectionType: selection[0].selectionType,
          leagueName: selection[0].leagueName,
          sportName: selection[0].sportName,
          eventDate: selection[0].eventDate,
          oddsid: selection[0].oddsid,
          teamType: selection[0].teamType,
          selectionId: selection[0].selectionId,
          teaserType: selection[0].teaserType,
          teaserTypeId: selection[0].teaserTypeId,
          teaserId: selection[0].teaserId
        }
        if (!teaserBets.teaserType && !teaserBets.teaserPoint) {
          teaserBets.teaserType = selection[0].teaserType
          teaserBets.teaserPoint = selection[0].teaserPoint
        }
      }
      return extraInfo
    }, {})

    teaserBets.legs.forEach((leg, index) => {
      if (Object.keys(extraInfo[leg.legId]).length > 0) {
        Object.assign(leg, extraInfo[leg.legId])
      }

      if (leg.pointStatus === Constants.TEASER_ERROR.POINT_CHANGE) {
        const selectionIdx = teaserSelections.findIndex(sel => {
          return sel.legId === leg.legId
        })
        const payloadIdx = JSON.parse(teaserOddsPayload.legs).findIndex(payloadLeg => {
          return payloadLeg.legId === leg.legId
        })
        const newSelectionId = leg.lineId + '|' + teaserSelections[selectionIdx].oddsId + '|' + teaserSelections[selectionIdx].teamType + '|' + leg.point;
        teaserSelections[selectionIdx].selectionId = newSelectionId
        teaserOddsPayload[payloadIdx].selectionId = newSelectionId
        leg.errorCode = Constants.TEASER_ERROR.SELECTION_POINT_CHANGED
      }
      if (leg.errorCode === Constants.TEASER_ERROR.POINTS_NO_LONGER_AVAILABLE || leg.errorCode === Constants.TEASER_ERROR.EVENT_NOT_FOUND) {
        leg.errorCode = Constants.TEASER_ERROR.EVENT_NOT_FOUND
      }
    })
    if(!teaserBets.minLegs){
      teaserBets.minLegs = minLegs
    }
    if (teaserBets.errorCode == null && (teaserBets.legs.length < teaserBets.minLegs)) {
      teaserBets.errorCode = Constants.TEASER_ERROR.TOO_FEW_LEGS;
    }
  }

  static isInValidStatus = (status) => {
    switch(status){
      case Constants.UNAVAILABLE:
      case Constants.INVALID_BET_ACCEPTANCE_TYPE:
      case Constants.HR_BET_STATUS.INVALID_SELECTION:
      case Constants.BET_ERROR_CODE.ROUND_ROBIN_DISALLOWED:
        return true;
      default: return false;
    }
  }

  /**
   * For single bet and parlay bet
   */
  static isDisablePlaceBetBtn  = (betItems) => {
    if (!betItems || Object.keys(betItems).length === 0) {
      return true
    } 
    let isDisable = false
    betItems.forEach((item, index) => {
      if ((item.errorCode 
        && item.errorCode !== Constants.BET_ERROR_CODE.LINE_CHANGED 
        && item.errorCode !== Constants.BET_ERROR_CODE.MAX_BET_EXCEEDED) || BetslipHelper.isInValidStatus(item.status) || BetslipHelper.isInValidStatus(item.legStatus)) {
          isDisable = true;
        }
    })
    return isDisable;
  }

  /**
   * Validate HR parlay bets mix
   */
   static isInValidMixedRBParlayBet  = (betItems) => {
    return betItems && betItems.some(item => item.sportId !== Constants.HORSE_RACING_ID) && betItems.some(item => item.sportId === Constants.HORSE_RACING_ID);
  }

  static isSuccessfullyBet = (status) => {
    if (status) {
      return status === Constants.HR_BET_STATUS.ACCEPTED || status === Constants.BET_STATUS.PENDING_ACCEPTANCE
    }
    return false
  }
  
  static isAllBetsSuccessfully = (bets) => {
    let totalBet = 0
    bets.forEach(bet => {
      if (BetslipHelper.isSuccessfullyBet(bet.status)) {
        totalBet += 1
      }
    })
    return totalBet === bets.length
  }

  static getWinRiskOptionByOdds = (odds) => {
    if (odds > 0) {
      return WinRiskType.RISK
    }
    return WinRiskType.WIN
  }
  
  static isEnterKey = (event) => {
    return event.key === 'Enter' || event.charCode === 13 || event.keyCode === 13
  }

  static scrollToBottom = (element) => {
    if (element.current) {
      const $betslipContent = $('.BetslipContentComponent')
      const isOpenConfirmationModal = $betslipContent.find('#confirmation-modal').length > 0;
      const onFocus = (element) => {
        if (isOpenConfirmationModal) {
          return;
        }
        element.focus();
      };

      const betslipHeight = $betslipContent.length > 0 ? $betslipContent.outerHeight() : 0
      if (betslipHeight > element.current.offsetHeight) {
        element.current.scrollTop = element.current.scrollHeight
      }
      const $parlayStakeContainer = $('.parlay-stake-container')
      const $teaserStakeContainer = $('.teaser-stake-container')
      if ($parlayStakeContainer.length > 0) {
        const $stake = $parlayStakeContainer.find('input[name="stake"]')
        if ($stake.length > 0) {
          onFocus($stake);
        }
      } else if ($teaserStakeContainer.length > 0) {
        let $stake = $teaserStakeContainer.find('input[name="risk"]');
        if ($stake.length === 0) {
          $stake = $teaserStakeContainer.find('input[name="stake"]');
        }
        if ($stake.length > 0) {
          onFocus($stake);
        }
      } else {
        const $betItems = $('.bet-body-item');
        if ($betItems.length > 1) {
          const $stake = $('.stake-per-bet-container').find('.stakePerBetRisk');
          onFocus($stake);
        } else {
          const $betItem = $betItems.last();
          let $stake = $betItem.find('input[name="risk"]');
          if ($stake.length === 0) {
            $stake = $betItem.find('input[name="stake"]');
          }
          onFocus($stake);
        }
      }
    }
  }

  static getSingleWinRiskInfo = (stakeInputs) => {
    let totalRisk = 0, totalWin = 0
    Object.values(stakeInputs).forEach(input => {
      totalRisk += BetslipCommon.convertStakeToNumber(input.riskVal)
      totalWin += BetslipCommon.convertStakeToNumber(input.winVal)

    })
    return {
      totalRisk: totalRisk,
      totalWin: totalWin
    }
  }

  static loadDefaultAcceptBetterOdds = () => {
    const __prefs = isEmpty(cookie.load('__prefs')) ? '' : CommonUtil.decodeBase64(cookie.load('__prefs'))
    const __prefsJSON = isEmpty(__prefs) ? {} : CommonUtil.convertStringToJSON(__prefs)
    if (!isEmpty(__prefsJSON)) {
      return __prefsJSON[PrefsMap.acceptBetterOdds]
    }
    return false
  }

  static formatEventDate = (date) => {
    if (isNaN(Number(date))) {
      return moment(date).format(Constants.BETSLIP_FORMAT_DATE)
    }
    return moment(new window.DateTZ(Number(date))).format(Constants.BETSLIP_FORMAT_DATE)
  }

  static cacheObjectInLocalStorage = (obj, objName) => {
    if (Object.keys(obj).length > 0) {
      localStorage.setItem(objName, Base64.encode(JSON.stringify(obj)))
    } else {
      localStorage.removeItem(objName)
    }
  }

  static updateMinMaxBet = (minMaxBets, bets, oddsFormat, isChangeOddsFormat) => {
    let newMinMaxBets = {}, winRiskOption = ''
    bets.forEach(bet => {
      if (isChangeOddsFormat || (minMaxBets && !minMaxBets[bet.oddsId])) { // reset win risk options in case: odds was changed or bet was added in the first time
        winRiskOption = BetslipHelper.getDefaultWinRiskOption(oddsFormat, bet.odds)
      }
      const minMaxBet = {
        oddsId: bet.oddsId,
        odds: bet.odds,
        winRiskOption: winRiskOption ? winRiskOption : minMaxBets[bet.oddsId].winRiskOption, // prevent reset to min value if auto refresh runs
        minStakeRisk: bet.minStakeRisk,
        minStakeWin: bet.minStakeWin,
        minStakeBase: bet.minStakeBase,
        maxStakeRisk: bet.maxStakeRisk,
        maxStakeWin: bet.maxStakeWin,
        maxStakeBase: bet.maxStakeBase,
        maxBetPerMatch: bet.maxBetPerMatch,
        maxBetPerMatchWin: bet.maxBetPerMatchWin,
        maxBetPerMatchBase: bet.maxBetPerMatchBase
      }
      newMinMaxBets[bet.oddsId] = minMaxBet
    })
    return newMinMaxBets
  }

  static getDefaultWinRiskOption = (oddsFormat, odds) => {
    let winRiskOption = ''
    if (oddsFormat === OddsFormat.AM || oddsFormat === OddsFormat.EU) {
      // default winRiskOptions is Risk for AM odds and EU odds
      winRiskOption = WinRiskType.RISK
    } else {
      winRiskOption = BetslipHelper.getWinRiskOptionByOdds(odds)
    }
    return winRiskOption
  }
  
  static isPlaceBetEventKey = (eventKey) => {
    const placeBetKeys = [EVENT.ALERT_CONFIRM_PLACEBET, EVENT.ALERT_CONFIRM_PLACEBET_PARLAY, EVENT.ALERT_CONFIRM_PLACEBET_TEASER, EVENT.ALERT_CONFIRM_PLACEBET_VS_SINGLE, EVENT.ALERT_CONFIRM_PLACEBET_VS_PARLAY]
    return placeBetKeys.indexOf(eventKey) > -1
  }

  static unFocusAllStakeInput = () => {
    $(".floating-label input").each((idx, input) => {
      $(input).blur()
    })
  }

  static getButtonSelection = (isTopLeague, favourite) => {
    return (
        isTopLeague
            ? BUTTON_SELECTION.TOP_LEAGUES
            : (
                favourite
                    ? BUTTON_SELECTION.MY_FAVOURITES
                    : BUTTON_SELECTION.ALL_EVENTS
            )
    )
  }

  static updateNewOdds = (newData, bets) => {
    const newOdds = newData.legs[0].userOdds;
    const updatedOddsId = BetslipHelper.buildHROddsId(newData.legs[0]);
    const betIndex = bets.findIndex(bet => bet.oddsId === updatedOddsId && bet.status !== Constants.HR_BET_STATUS.ACCEPTED);
    const matchingBet = bets[betIndex];
    if (matchingBet) {
      const newBet = {
        ...matchingBet,
        oldDisplayOdds: matchingBet.oddsDisplay,
        oddsDisplay: newOdds,
        odds: newOdds,
        status: Constants.HR_BET_STATUS.PRICE_CHANGED,
        betSlipEmit: newData,
      };
      return {
        updatedSingleBets: [
          ...bets.slice(0, betIndex),
          newBet,
          ...bets.slice(betIndex + 1),
        ],
        updatedOddsId,
        newOdds
      };
    }
    return {
      updatedSingleBets: bets,
      updatedOddsId,
      newOdds
    }
  }

  static buildGetLimitPayload = (bets, oddsFormat, timeZoneId) => {
    const revertedOddsFormatHR = {};
    Object.entries(OddsFormatHR).forEach(([key, value]) => {
      revertedOddsFormatHR[value] = key;
    });
    return bets.map(item => {
      const {betSlipEmit} = item;
      const legType = betSlipEmit.legs[0].type;
      const raceDate = getMomentTZ(betSlipEmit.legs[0].startTime, timeZoneId);
      
      return {
        oddsFormat: revertedOddsFormatHR[oddsFormat],
        type: 'SINGLE',
        stake: 0,
        uniqueRequestId: BetslipCommon.generateUUID(),
        legs: [
          {
            ...betSlipEmit.legs[0],
            raceDate,
            type: legType,
          }
        ]
      }
    });
  }

  static buildGetParlayLimitPayload = (bets, oddsFormat) => {
    const {betSlipEmit} = bets[0];
    const {
      legs,
    } = betSlipEmit;
    const revertedOddsFormatHR = {};
    Object.entries(OddsFormatHR).forEach(([key, value]) => {
      revertedOddsFormatHR[value] = key;
    });
    const legType = legs[0].type;
    const raceDate = betSlipEmit.legs[0].startTime;
    const updatedLegs = bets.map(item => {
      const {betSlipEmit} = item;
      return {
        ...betSlipEmit.legs[0],
        raceDate,
        type: legType,
      }
    });
    return [{
      oddsFormat: revertedOddsFormatHR[oddsFormat],
      type: 'MULTI',
      stake: 0,
      uniqueRequestId: BetslipCommon.generateUUID(),
      legs: updatedLegs,
    }]
  }

  static buildPlaceHRParlayBetPayload = (bets, winRiskOption, parlayStake, oddsFormat) => {
    const {betSlipEmit, currencyCode} = bets[0];
    const revertedOddsFormatHR = {};
    Object.entries(OddsFormatHR).forEach(([key, value]) => {
      revertedOddsFormatHR[value] = key;
    });
    const {
      legs,
    } = betSlipEmit;
    const legType = legs[0].type;
    const raceDate = betSlipEmit.legs[0].startTime;
    const updatedLegs = bets.map(item => {
      const {betSlipEmit} = item;
      return {
        ...betSlipEmit.legs[0],
        raceDate,
        type: legType,
      }
    });
    return [{
      winRiskOption,
      oddsFormat: revertedOddsFormatHR[oddsFormat],
      type: 'MULTI',
      stake: Number((parlayStake ? parlayStake.toString().replaceAll(Constants.THOUSANDS_SEPARATOR, '') : 0)),
      currency: currencyCode,
      legs: updatedLegs,
      uniqueRequestId: BetslipCommon.generateUUID(),
    }]
  }

  static getDefaultMinMaxHRBet = (sportId) => {
    const __udata = CommonUtil.getUserData();
    const defaultLimit = __udata.defaultRBLimit;
    const defaultMinBet = _.get(defaultLimit, `[${sportId}].minBet`, _.get(defaultLimit, `[0].minBet`, 1));
    const defaultMaxBet = _.get(defaultLimit, `[${sportId}].maxBet`, _.get(defaultLimit, `[0].maxBet`, 0));
    return {
      defaultMinBet,
      defaultMaxBet,
    }
  }

  static updatedCorrelatedLegs = (legs) => {
    if(legs && legs.length > 0) {
      const notCorrelatedLegs = legs.find(leg => _.isNil(leg.errorCode));
      if(notCorrelatedLegs) {
        return legs;
      } else {
        const updatedLegs = JSON.parse(JSON.stringify(legs[0]));
        updatedLegs.errorCode = null;
        legs[legs.findIndex(leg => leg.legId === updatedLegs.legId)] = updatedLegs;
        return legs;
      }
    }
    return legs;
  }

  static buildBetslipItem = (item, selectedBetslipTab, t, currency, parlayLegs, timeZoneId) => {
    const {
      startTime,
      betType,
      runnerName,
      raceNumber,
      runnerNumber,
      odds,
      userOdds,
      raceName,
      meetingId,
    } = item.legs[0];
    const {type} = item;
    let errorCode;
    if (type === 'MULTI' && parlayLegs) {
      const correlatedIndex = parlayLegs.filter(bet => bet.status !== Constants.HR_BET_STATUS.ACCEPTED).findIndex(bet => bet.raceNumber === raceNumber && bet.meetingId === meetingId);
      errorCode = correlatedIndex >= 0 && Constants.BET_ERROR_CODE.CORRELATED
    }
    const dateTime = getMomentTZ(startTime, timeZoneId);
    const date = dateTime.format('YYYY-MM-DD');
    const oddsId = BetslipHelper.buildHROddsId(item.legs[0]);
    return {
      selectedAt: moment().unix(),
      betExtraInfo: `${date}\u00A0\u00A0${_.capitalize(t(`${betType}_rb`))}`,
      selectionInfo: `${runnerNumber} ${runnerName}`,
      errorCode,
      runnerNumber,
      betType,
      oddsDisplay: BetslipCommon.convertStakeToNumber(userOdds),
      odds,
      oddsId,
      raceName,
      raceNumber,
      meetingId,
      legId: oddsId,
      currencyCode: currency,
      betSlipEmit: item,
      sportId: Constants.HORSE_RACING_ID,
      isHRParlay: selectedBetslipTab === BETSLIP_TABS.PARLAY,
    };
  }

  /**
   * Selection is passed from b2b site to iframe. It should be followed the format as bellow:
   * {
   *    eventId: number
   *    period: number
   *    betType: string (SPREAD | MONEYLINE | TOTAL_POINTS | TEAM_TOTAL_POINTS | OUTRIGHT)
   *    altLineId: numer
   *    team: string (HOME | AWAY)
   *    hdp: number
   *    points: number
   *    contestantLineId: number (for outright event)
   *    side: string (OVER | UNDER)
   * }
   * 
   */

  static buildSelectionFromIframe = (selection, userOddsFomrat) => {
    const {
      eventId,
      period,
      betType,
      team,
      altLineId,
      hdp,
      points,
      side,
      contestantLineId
    } = selection;

    const isOutright = [
      SimplifiedBetType.SPECIALS, 
      SimplifiedBetType.OUTRIGHT
    ].includes(SimplifiedBetType[betType]);

    const teamType = 0; // to by pass validation line change in backend side
    const lineId = 1;  // to by pass validation line change in backend side

    const alt = altLineId > 0 ? 1 : 0;
    const isTeamTotalPoints = [SimplifiedOriginalBetType.TEAM_TOTAL_POINTS].includes(betType);
    const isTotalPoints = [SimplifiedOriginalBetType.TOTAL_POINTS].includes(betType);

    const bt = isTeamTotalPoints
      ? SimplifiedBetType[`${team}_${betType}`.toUpperCase()]
      : SimplifiedBetType[betType]

    let selectionType = SimplifiedSelectionType[team];
    if (isTeamTotalPoints || isTotalPoints) {
      selectionType = isTeamTotalPoints
        ? SimplifiedSelectionType[`${team}_${side}_${betType}`.toUpperCase()]
        : SimplifiedSelectionType[`${side}_${betType}`.toUpperCase()]
    } else if (isOutright) {
      selectionType = SimplifiedSelectionType[SimplifiedOriginalBetType.OUTRIGHT];
    }

    const spread = isTeamTotalPoints || isTotalPoints 
      ? points
      : hdp;

    const oddsId = isOutright
      ? [eventId, period, bt, selectionType, alt, spread, contestantLineId].join("|")
      : [eventId, period, bt, selectionType, alt, spread].join("|");

    // get current odds value
    const oddsElement = document.getElementById(oddsId);
    const odds = oddsElement ? Number(oddsElement.text) : "";

    return {
      selectedAt: moment().unix(),
      oddsFormat: userOddsFomrat,
      oddsId: oddsId,
      teamType: teamType,
      parlayRestriction: 0,
      oddsSelectionsType: isOutright 
        ? Constants.WAGER_TYPE.OUTRIGHT 
        : Constants.WAGER_TYPE.NORMAL,
      selectionId: [lineId, oddsId, teamType].join('|'),
      odds: odds
    }
  }
  
  /**
   * Parse selection id is returned from /all-odds-selection services.
   * This function used for selection id which includes altLineId
   * @param {*} selectionId 
   * @returns 
   */
  static parseSelectionIdWithAltLineId = (selectionId) => {
     const parts = selectionId.split('|');
     if (parts.length === 9) {
      return {
        lineId: parts[0],
        altLineId: parts[1],
        eventId: parts[2],
        period: parts[3],
        betType: parts[4],
        selectionType: parts[5],
        isAlt: parts[6],
        handicap: parts[7],
        teamType: parts[8]
      }
    }
    return {};
  }
  
  /**
   * Parse selection id is returned from /all-odds-selection services.
   * This function used for selection id which does not include altLineId
   * @param {*} selectionId 
   * @returns 
   */
  static parseSelectionIdWithoutAltLineId = (selectionId) => {
    const parts = selectionId.split('|');
    if (parts.length === 8) {
     return {
       lineId: parts[0],
       eventId: parts[1],
       period: parts[2],
       betType: parts[3],
       selectionType: parts[4],
       isAlt: parts[5],
       handicap: parts[6],
       teamType: parts[7]
     }
   }
   return {};
 }

 /**
  * Parse selection id is returned from /all-odds-selection services.
  * This function used for selection id which includes contestantLineId
  * @param {*} selectionId 
  * @returns 
  */
 static parseSelectionIdWithContestantLineId = (selectionId) => {
  const parts = selectionId.split('|');
    if (parts.length === 9) {
      return {
        lineId: parts[0],
        eventId: parts[1],
        period: parts[2],
        betType: parts[3],
        selectionType: parts[4],
        isAlt: parts[5],
        handicap: parts[6],
        contestantLineId: parts[7],
        teamType: parts[8]
      }
    }
  }

  static calculateBaseVal = (isCalculate, odd, riskValue, winValue) => {
    if (!isCalculate) return '';
    const option = BetslipHelper.getWinRiskOptionByOdds(odd);
    return option === WinRiskType.RISK ? riskValue : winValue;
  }

  static isDefaultAttention = (attention, selectedBetslipTab) => {
    const attentionByType = attention[selectedBetslipTab];
    return attentionByType.message === Constants.ATTENTION_MESSAGE.ATTENTION;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/CompactView/LeftSideBarComponent/BetslipComponent/BetslipHelper.js